module.exports = __webpack_public_path__ + "img/ico_menual08_off.8eabd9c1.svg";